<template>
  <b-dialog :name="'apartment-profile'" width="800" @before-open="getData" @closed="clearData">
    <form class="uk-form-horizontal b-form num-form" autocomplete="off" @submit.prevent="">
      <div v-if="errorMessage" class="uk-alert-danger uk-animation-slide-bottom-small" uk-alert>
        <p>{{ errorMessage }}</p>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="passport"
          >Идентификационный номер (личный номер)<span class="req-star top">*</span></label
        >
        <div class="form-column--right">
          <!--          <b-input-->
          <!--            v-model="details.passport"-->
          <!--            id="passport"-->
          <!--            type="search"-->
          <!--            :upper="true"-->
          <!--            class="upper-text"-->
          <!--            :class="{'uk-form-danger uk-animation-shake': $v.details.passport.$error}"-->
          <!--          />-->
          <div class="b-form-redonly__block upper-text">
            {{ details.passport }}
          </div>
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="surname"
          >Фамилия <span class="req-star">*</span></label
        >
        <div class="form-column--right">
          <b-input
            v-model.trim="details.surname"
            id="surname"
            key="surname"
            type="search"
            :class="{'uk-form-danger uk-animation-shake': $v.details.surname.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="name">Имя <span class="req-star">*</span></label>
        <div class="form-column--right">
          <b-input
            v-model.trim="details.name"
            id="name"
            key="name"
            type="search"
            :class="{'uk-form-danger uk-animation-shake': $v.details.name.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="patronymic"
          >Отчество <span class="req-star">*</span></label
        >
        <div class="form-column--right">
          <b-input
            v-model.trim="details.patronymic"
            id="patronymic"
            key="patronymic"
            type="search"
            :class="{'uk-form-danger uk-animation-shake': $v.details.patronymic.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="phone-number"
          >Номер телефона <span class="req-star">*</span></label
        >
        <div class="form-column--right">
          <b-input
            v-model="details.phone"
            id="phone-number"
            key="phone"
            type="search"
            :mask="'phone'"
            :class="{'uk-form-danger uk-animation-shake': $v.details.phone.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle">
        <label class="form-column--left" for="email">Email</label>
        <div class="form-column--right">
          <b-input
            v-model.trim="details.email"
            id="email"
            key="email"
            type="search"
            :class="{'uk-form-danger uk-animation-shake': $v.details.email.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex">
        <label class="form-column--left">Статус</label>
        <div class="form-column--right">
          <span
            v-if="details.connected"
            uk-icon="icon: check; ratio: 0.8"
            style="color: #0FB269"
          ></span>
          <span v-else uk-icon="icon: close; ratio: 0.8" style="color: #E31E24"></span>
          <span
            class="uk-margin-small-left"
            v-text="details.connected ? 'Подключен' : 'Не подключен'"
          ></span>
        </div>
      </div>
      <div class="uk-margin-small uk-flex">
        <label class="form-column--left">Тип жильца <span class="req-star">*</span></label>
        <div class="form-column--right radio-group uk-flex-wrap">
          <b-radio v-model="details.ownershipType" value="OWNER" name="type" checked>
            Собственник
          </b-radio>
          <b-radio v-model="details.ownershipType" value="REPRESENTATIVE" name="type">
            Представитель собственника
          </b-radio>
          <b-radio
            v-model="details.ownershipType"
            value="TENANT"
            name="type"
            @change="validOwnership"
          >
            Арендатор
          </b-radio>
        </div>
      </div>
      <div
        v-if="details.ownershipType === 'OWNER' || details.ownershipType === 'REPRESENTATIVE'"
        class="uk-margin-small uk-flex uk-flex-middle uk-animation-slide-bottom-small"
      >
        <label class="form-column--left" for="ownership"
          >Доля собственности <span class="req-star">*</span></label
        >
        <div class="form-column--right">
          <b-input
            v-model="details.ownershipShare"
            id="ownership"
            key="ownershipShare"
            type="number"
            min="1"
            :uk-tooltip="`title: Доступно ${getOwnershipShareAvailable}%; delay: 500`"
            :max="getOwnershipShareAvailable"
            style="width: 100px;"
            :class="{'uk-form-danger uk-animation-shake': $v.details.ownershipShare.$error}"
          />
          <span style="margin-left: 10px">%</span>
        </div>
      </div>
      <div
        v-if="details.ownershipType === 'REPRESENTATIVE'"
        class="uk-margin-small uk-flex uk-flex-middle uk-animation-slide-bottom-small"
      >
        <label class="form-column--left" for="document"
          >Номер документа <span class="req-star">*</span></label
        >
        <div class="form-column--right">
          <b-input
            v-model.trim="details.document"
            id="document"
            key="document"
            type="search"
            :class="{'uk-form-danger uk-animation-shake': $v.details.document.$error}"
          />
        </div>
      </div>
      <div class="uk-margin-small uk-flex">
        <label class="form-column--left top" for="notes">Примечание</label>
        <div class="form-column--right">
          <b-textarea
            v-model.trim="details.note"
            id="notes"
            cols="56"
            rows="4"
            :class="{'uk-form-danger uk-animation-shake': $v.details.notes.$error}"
          />
        </div>
      </div>
    </form>
    <div class="uk-flex uk-flex-center">
      <b-button name="Сохранить" color="red" class="margin-right_60" @click="save" />
      <b-button name="Отменить" @click="$modal.hide('apartment-profile')" />
    </div>
  </b-dialog>
</template>

<script>
import {maxLength, required, requiredIf, minLength} from 'vuelidate/lib/validators'
import {email, alphaNumAndLetter} from '@/common/utils/vuelidate'
import {replaceValue} from '@/common/utils/replaceValue'
import {showSuccess} from '@/common/utils/notification'

import {mapActions} from 'vuex'

function validateOwnershipShare(val) {
  if (this.details.ownershipType !== 'TENANT') {
    return val >= 1 && val <= 100 - this.ownershipShareOccupied
  }
  return true
}

export default {
  name: 'EditProfileFormDialog',
  props: {
    tenant: {
      type: Object,
      default: () => ({})
    },
    occupants: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      details: {},
      errorMessage: '',
      ownershipShareOccupied: 0
    }
  },
  methods: {
    ...mapActions({
      saveApartmentCard: 'apartment/SAVE_APARTMENT_CARD'
    }),
    save() {
      this.$v.details.$touch()
      if (!this.$v.details.$error) {
        let occupantSaveRequestBody = {
          email: this.details.email,
          occupantId: +this.details.occupantId,
          name: this.details.name,
          patronymic: this.details.patronymic,
          phone: replaceValue(this.details.phone),
          surname: this.details.surname,
          passport: this.details.passport,
          apartmentId: this.details.apartmentId,
          document: this.details.ownershipType === 'REPRESENTATIVE' ? this.details.document : '',
          note: this.details.note,
          ownershipShare: this.details.ownershipShare,
          ownershipType: this.details.ownershipType
        }

        this.saveApartmentCard(occupantSaveRequestBody)
          .then(() => {
            this.$emit('update')
            showSuccess('Изменения успешно сохранены')
            this.$modal.hide('apartment-profile')
          })
          .catch(err => {
            this.errorMessage = {err}.err.response.data
          })
      } else {
        this.errorMessage = 'Правильно заполните поля!'
      }
    },
    getData() {
      this.details = {...this.tenant}
    },
    getOwnershipShareOccupied() {
      this.ownershipShareOccupied = 0
      this.occupants.forEach(el => {
        if (el.occupantId !== this.details.occupantId)
          this.ownershipShareOccupied += el.ownershipShare
      })
    },
    validOwnership(value) {
      if (value === 'TENANT') this.details.ownershipShare = 0
    },
    clearData() {
      this.details = {}
      this.errorMessage = ''
    }
  },
  computed: {
    getOwnershipShareAvailable() {
      return 100 - this.ownershipShareOccupied
    }
  },
  watch: {
    'details.ownershipShare'() {
      this.getOwnershipShareOccupied()
    }
  },
  validations: {
    details: {
      surname: {
        required,
        maxLength: maxLength(200)
      },
      name: {
        required,
        maxLength: maxLength(200)
      },
      patronymic: {
        required,
        maxLength: maxLength(200)
      },
      phone: {
        required,
        maxLength: maxLength(18),
        minLength: minLength(18)
      },
      email: {
        maxLength: maxLength(50),
        email
      },
      ownershipType: {
        required: requiredIf(function(tenant) {
          return tenant.ownershipType === 'TENANT'
        })
      },
      ownershipShare: {
        required: requiredIf(function(tenant) {
          return tenant.ownershipType !== 'TENANT'
        }),
        between: validateOwnershipShare
      },
      notes: {
        maxLength: maxLength(1000)
      },
      document: {
        required: requiredIf(function(tenant) {
          return tenant.ownershipType === 'REPRESENTATIVE'
        }),
        maxLength: maxLength(20)
      },
      passport: {
        required,
        maxLength: maxLength(14),
        alphaNumAndLetter
      }
    }
  }
}
</script>
